module.exports = __webpack_public_path__ + "img/blog-default.deb1da5.jpg";